module.exports = __webpack_public_path__ + "/images/logo-prenatal-it.587bf97.png";